import { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const BirthdayIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M20 21.5V13.5C20 12.9696 19.7893 12.4609 19.4142 12.0858C19.0391 11.7107 18.5304 11.5 18 11.5H6C5.46957 11.5 4.96086 11.7107 4.58579 12.0858C4.21071 12.4609 4 12.9696 4 13.5V21.5M4 16.5C4 16.5 4.5 15.5 6 15.5C7.5 15.5 8.5 17.5 10 17.5C11.5 17.5 12.5 15.5 14 15.5C15.5 15.5 16.5 17.5 18 17.5C19.5 17.5 20 16.5 20 16.5M2 21.5H22M7 8.5V11.5M12 8.5V11.5M17 8.5V11.5M7 4.5H7.01M12 4.5H12.01M17 4.5H17.01"
      stroke={props.color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
